export default __webpack_public_path__ + "static/media/black_info.6096adf3.svg";